<template>
  <section id="things-to-know" class="bg-beige1">
    <h2 class="pt-12 text-center font-Spectral text-[32px] font-medium leading-[40px] tracking-[0.5px] text-[#826B3D] md:pt-7 md:text-4xl md:leading-[48px]">Things to Know</h2>
    <div class="pb-6 pt-2 md:pb-14">
      <div class="mx-auto w-12 border-b border-gold1 md:w-14" />
    </div>
    <div class="px-4 md:mx-[5%] md:px-0 e2:m-auto e2:max-w-6xl">
      <div class="text-base md:px-[8%] lg:m-auto lg:max-w-[832px] lg:p-0">
        <div class="font-Spectral">
          <div v-if="drawerTabs.length > 0" class="mb-6 flex w-full flex-col items-stretch lg:w-[832px]">
            <DrawerTabListItem v-for="(tab, index) in drawerTabs" :key="index" :heading="tab.tabName" :on-open-detail="() => onOpenDrawerTab(index, tab.tabName)" />
          </div>
          <!-- FAQ Section -->
          <div v-if="experienceCms.faq && experienceCms.faq.length > 0" class="border-b border-gray1 py-4">
            <h3 class="font-Spectral text-base font-normal text-gold1">FAQ</h3>
            <div class="mt-2">
              <FaqSection :categorized-faqs="experienceCms.faq" :default-show-count="3" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { extractVisibleDrawerTabs, type EnExperienceViewModel } from '@/models/enExperience';
import DrawerTabListItem from '@/wabunka-src/features/Experience/pages/ExperienceDetail/components/pure/DrawerTabListItem/DrawerTabListItem.vue';
import FaqSection from '@/wabunka-src/features/FAQ/components/FaqSection/FaqSection.vue';

interface Props {
  experienceCms: EnExperienceViewModel;
  onOpenDrawerTab: (index: number, label: string) => void;
}
const props = defineProps<Props>();
const drawerTabs = computed(() => extractVisibleDrawerTabs(props.experienceCms.drawerTabs));
</script>
